import { render } from "./AddAbsence.vue?vue&type=template&id=055f22c2"
import script from "./AddAbsence.vue?vue&type=script&lang=js"
export * from "./AddAbsence.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/halisclock/releases/44/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__